<template>
  <div>
    <v-layout wrap class="mb-4">
      <v-flex xs9>
        <h3 class="headline mt-0">
          <img src="/static/img/akita.png" alt />
        </h3>
      </v-flex>
      <v-flex xs3 class="text-xs-right">
        <template v-if="$store.getters.getPackage == 'premium'">
          <v-btn fab outline small color="primary" v-if="!isEdit" @click="editAkita">
            <em class="fa fa-pencil-alt middle" />
          </v-btn>
        </template>
        <template v-else>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn readonly fab outline small color="grey" v-on="on">
                <v-icon>lock</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Upgrade to Premium Plan') }}</span>
          </v-tooltip>
        </template>
      </v-flex>
    </v-layout>
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <template v-else>
      <div class="mb-2" v-if="token != null">
        <div>
          {{ $t('เปิด/ปิด การใช้งาน Akita') }}
        </div>
        <div>
          <label
            class="toggle-switch small"
            style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
          >
            <input :disabled="loading" type="checkbox" :checked="status" @change="toggleStatus()" />
            <span class="toggle-slider lever round"></span>
          </label>
        </div>
      </div>

      <div class="form-control" :class="{ 'has-error': errors.has('token') }">
        <div class="caption mt-2">Token</div>
        <template v-if="isEdit">
          <input
            type="text"
            v-model="token"
            v-validate="'required'"
            name="token"
            data-vv-as="Token"
          />
          <span class="text-error" v-if="errors.has('token')">{{ errors.first('token') }}</span>
        </template>
        <div class="primary--text" v-else>
          {{ token ? token : '-' }}
        </div>
      </div>

      <div class="text-xs-center" v-if="isEdit">
        <v-btn color="grey" outline @click="onCancel">
          {{ $t('cancel') }}
        </v-btn>
        <v-btn color="primary" depressed @click="onSave">
          {{ $t('Save') }}
        </v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'

export default {
  data() {
    return {
      isEdit: false,

      loading: false,
      token: null,
      status: false
    }
  },
  async mounted() {
    this.loading = true
    var response = await this.getakita()
    if (response.data && response.data.length > 0) {
      try {
        this.status = response.data[0].akita_status
        if (response.data[0].akita_token) this.token = response.data[0].akita_token
      } catch (error) {}
    }
    this.loading = false
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  methods: {
    async toggleStatus() {
      var vm = this
      const status = !vm.status
      try {
        await vm.saveAkita({
          params: {
            pageid: vm.selectedBot.pageid
          },
          body: {
            akita_status: status,
            akita_token: vm.token
          }
        })
        await this.$store.dispatch('updateBotDetail')
        vm.status = status
      } catch (error) {
        console.log(error)
      }
    },
    getakita() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getakita({ pageid: vm.selectedBot.pageid }, (error, response) => {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    editAkita() {
      this.isEdit = true
      this.cached_token = this.token
      this.cached_status = this.status
    },
    onCancel() {
      this.isEdit = false
      this.token = this.cached_token
      this.status = this.cached_status
    },
    async saveAkita(data) {
      return new Promise((resolve, reject) => {
        api.saveakita(data, (error, response) => {
          if (error) {
            reject(error)
          }

          resolve(response)
        })
      })
    },
    async onSave() {
      try {
        if (this.token != null && this.status == null) this.status = true
        var result = await this.$validator.validateAll()
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        await this.saveAkita({
          params: {
            pageid: this.selectedBot.pageid
          },
          body: {
            akita_status: this.status,
            akita_token: this.token
          }
        })
        await this.$store.dispatch('updateBotDetail')

        await this.$swal.fire({
          title: this.$t('Successfully'),
          type: 'success'
        })

        this.cached_token = this.token
        this.cached_status = this.status

        this.isEdit = false
      } catch (error) {}
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/AkitaManage.vue